export const buttonAdd = "Aggiungi";
export const buttonAddNewSource = "Aggiungi nuovo";
export const buttonAddSource = "Aggiungi fonte";
export const buttonAddTopic = "Aggiungi topic";
export const buttonAddUser = "Aggiungi utente";
export const buttonAnnul = "Annulla";
export const buttonBack = "Indietro";
export const buttonBackToLogin = "Torna al login";
export const buttonConfirm = "Conferma";
export const buttonDelete = "Elimina";
export const buttonDeleteAccount = "Elimina account";
export const buttonExit = "Esci";
export const buttonExitWithoutSave = "Esci senza salvare";
export const buttonHide = "Nascondi";
export const buttonInvite = "Invita";
export const buttonLeave = "Abbandona";
export const buttonLogin = "Accedi";
export const buttonLogout = "Logout";
export const buttonNewProject = "Nuovo progetto";
export const buttonNext = "Avanti";
export const buttonRegister = "Registrati";
export const buttonRemove = "Rimuovi";
export const buttonResend = "Invia di nuovo";
export const buttonSaveUpdate = "Salva modifiche";
export const buttonSelect = "Seleziona";
export const buttonShowAll = "Mostra tutte";
export const buttonSendEmail = "Invia email";
export const buttonUpdatePassword = "Modifica Password";
export const buttonView = "Visualizza";
export const buttonResolveReport = "Risolvi segnalazione";
export const buttonPreserveAnswer = "Preserva risposta";
export const buttonDeleteAnswer = "Elimina risposta";
export const buttonFixAnswer = "Correggi risposta";
export const buttonSend = "Invia";
